module.exports = __webpack_public_path__ + "static/media/ic-enfermagem-min.64923144.svg";